import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('bia-chat-launcher')
export class BiaChatLauncher extends LitElement {
  static styles = css`
    :host { display: inline-block; }
    button {
      position: relative;
      width: 56px;
      height: 56px;
      border-radius: 16px;
      background: var(--bia-primary, #1A1A2E);
      color: var(--bia-primary-text, #FAFAF7);
      border: none;
      box-shadow: var(--bia-shadow-launcher, 0 12px 32px -8px rgba(15, 15, 14, 0.30));
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      transition: transform 220ms cubic-bezier(0.16, 1, 0.3, 1),
                  box-shadow 220ms cubic-bezier(0.16, 1, 0.3, 1);
    }
    button::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: inherit;
      padding: 1px;
      background: linear-gradient(160deg, rgba(255,255,255,0.22), rgba(255,255,255,0));
      -webkit-mask:
        linear-gradient(#000 0 0) content-box,
        linear-gradient(#000 0 0);
      -webkit-mask-composite: xor;
              mask-composite: exclude;
      pointer-events: none;
    }
    button:hover {
      transform: translateY(-2px);
      box-shadow: 0 18px 40px -10px rgba(15, 15, 14, 0.36),
                  0 6px 16px -4px rgba(15, 15, 14, 0.22);
    }
    button:hover .icon {
      transform: rotate(-6deg) scale(1.06);
    }
    button:active {
      transform: translateY(0);
      transition-duration: 90ms;
    }
    .icon {
      width: 26px;
      height: 26px;
      display: inline-block;
      transition: transform 280ms cubic-bezier(0.16, 1, 0.3, 1);
    }
    .icon svg {
      width: 100%;
      height: 100%;
      fill: currentColor;
    }
    .pulse {
      position: absolute;
      inset: -2px;
      border-radius: inherit;
      border: 1px solid var(--bia-primary, #1A1A2E);
      opacity: 0;
      animation: pulse 3.6s ease-out infinite;
      pointer-events: none;
    }
    @keyframes pulse {
      0%   { opacity: 0;   transform: scale(1); }
      18%  { opacity: 0.18; }
      60%  { opacity: 0;   transform: scale(1.18); }
      100% { opacity: 0;   transform: scale(1.18); }
    }
  `;

  private onClick(): void {
    this.dispatchEvent(new CustomEvent('open', { bubbles: true, composed: true }));
  }

  render() {
    return html`
      <button @click=${this.onClick} aria-label="Abrir BIA" title="Abrir BIA">
        <span class="pulse"></span>
        <span class="icon">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 2.5 13.65 9.05 20.2 10.7 13.65 12.35 12 18.9 10.35 12.35 3.8 10.7 10.35 9.05Z" />
            <path d="M18.5 14.5 19.2 17 21.7 17.7 19.2 18.4 18.5 20.9 17.8 18.4 15.3 17.7 17.8 17Z" />
            <path d="M6 3 6.45 4.65 8.1 5.1 6.45 5.55 6 7.2 5.55 5.55 3.9 5.1 5.55 4.65Z" />
          </svg>
        </span>
      </button>
    `;
  }
}
